import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=f0060d5c&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0060d5c')) {
      api.createRecord('f0060d5c', component.options)
    } else {
      api.reload('f0060d5c', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=f0060d5c&", function () {
      api.rerender('f0060d5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-258xmjW425xN6/JS/comp/ImgFallback2.vue"
export default component.exports